module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', [(!_vm.disableButton) ? _c('div', [_c('authorized-link', {
    attrs: {
      "tag": "create_tax"
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin ls-float-right",
    attrs: {
      "to": {
        path: 'taxes/new'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('taxes.buttons.new_tax')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('filter-tax'), _vm._v(" "), _c('div', [(_vm.taxes.length) ? _c('table', {
    staticClass: "ls-table ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.scope')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('taxes.attributes.status')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.taxes), function(tax, index) {
    return _c('tr', {
      attrs: {
        "data-test": "tax"
      }
    }, [_c('td', {
      attrs: {
        "data-test": "tax.id"
      }
    }, [_vm._v(_vm._s(tax.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "tax.name"
      }
    }, [_vm._v(_vm._s(tax.name))]), _vm._v(" "), _c('td', {
      staticClass: "ls-no-padding-right",
      attrs: {
        "data-test": "tax.value"
      }
    }, [_vm._v(_vm._s((tax.value)) + "%")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "tax.scope"
      }
    }, [_vm._v(_vm._s(tax.scope))]), _vm._v(" "), _c('td', {
      class: tax.active ? 'active-tax' : 'inactive-tax'
    }, [_c('span', {
      staticClass: "ls-display-inline-block",
      attrs: {
        "data-test": "tax.status"
      }
    }, [_vm._v(_vm._s(_vm.$t('taxes.attributes.statuses.' + tax.active)))])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "ls-btn ls-no-margin ls-float-right",
      attrs: {
        "to": {
          name: 'tax_details',
          params: {
            id: tax.id
          }
        }
      },
      slot: "button"
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ls-display-none-xs"
    }, [_vm._v(_vm._s(_vm.$t('application.button.detail')))])])], 1)])
  }))]) : _c('div', {
    attrs: {
      "role": "alert"
    }
  }, [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.getTaxes
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0975e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/taxes/Main.vue
// module id = 739
// module chunks = 1